import { motion, useReducedMotion } from "framer-motion";

export const revealVariants = {
  hidden: { opacity: 0, y: 30 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
  },
};

export const staggerVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1, delayChildren: 0.05 } },
};

// Single element reveal on scroll
export const Reveal = ({ children, className, delay = 0, y = 30, as = "div", amount = 0.12 }) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={reduce ? {} : { opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </MotionTag>
  );
};

// Stagger container; children should use <RevealItem/>
export const RevealGroup = ({ children, className, amount = 0.08 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      variants={staggerVariants}
      initial={reduce ? false : "hidden"}
      whileInView={reduce ? {} : "show"}
      viewport={{ once: true, amount }}
    >
      {children}
    </motion.div>
  );
};

export const RevealItem = ({ children, className, y = 28 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      variants={
        reduce
          ? undefined
          : { hidden: { opacity: 0, y }, show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } } }
      }
    >
      {children}
    </motion.div>
  );
};
